// A partir desse tempo (em segundos) o valor é exibido em destaque nas telas de log
export const SLOW_DURATION_SECONDS = 10;

export const isSlowDuration = (seconds?: number | null) =>
  seconds !== null && seconds !== undefined && seconds >= SLOW_DURATION_SECONDS;

// Soma dos tempos (Tasy → Captura + Captura → Envio); nulo se algum dos dois ainda não existir
export const sumDurationSeconds = (
  tasyToCaptureSeconds?: number | null,
  captureToSentSeconds?: number | null,
) =>
  tasyToCaptureSeconds === null ||
  tasyToCaptureSeconds === undefined ||
  captureToSentSeconds === null ||
  captureToSentSeconds === undefined
    ? null
    : tasyToCaptureSeconds + captureToSentSeconds;

// Formata segundos: "45s", "02:15" (mm:ss) ou "01:02:15" (hh:mm:ss); nulo vira "-"
export function formatDurationSeconds(seconds?: number | null): string {
  if (seconds === null || seconds === undefined) return "-";

  if (seconds < 60) return `${seconds}s`;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const pad = (value: number) => String(value).padStart(2, "0");

  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
    : `${pad(minutes)}:${pad(secs)}`;
}
